import { ExternalScheduleOrderDialogOption } from './types';

export const options: ExternalScheduleOrderDialogOption[] = [
  'manualConcreteOrder',
  'concreteDirectOrder',
];
